module.exports = __webpack_public_path__ + "img/guan.acb8cb13.svg";